@if (notification) {
    <article
        class="container"
        [ngClass]="{ unread: !notification.isRead, panel: isPanel }"
        tabindex="0"
        (keyup.enter)="onClick(notification.id)"
        (click)="onClick(notification.id)"
    >
        <section class="contentWrapper">
            <div class="icon" [innerHTML]="svg"></div>
            <div class="textWrapper">
                <span class="time timePanel">{{ timeAgoDate }}</span>
                <a
                    class="title"
                    [ngClass]="{ link: url }"
                    [routerLink]="url ? url : null"
                    [attr.href]="url ? null : '#'"
                    (mousedown)="handleMouseClick($event, notification.id)"
                >
                    {{ notification.title }}
                </a>
                <span class="message">
                    {{ notification.message }}
                </span>
            </div>
        </section>
        <section class="statusWrapper">
            <span class="time timePage">{{ timeAgoDate }}</span>
            <div class="unreadDotContainer">
                @if (!notification.isRead) {
                    <div class="unreadDot"></div>
                }
            </div>
        </section>
    </article>
}
